// @flow
import React from 'react'
import classnames from 'classnames'
import Icon from './Icon'

type PropsT = {
  id?: string,
  className?: string,
  stroke?: string,
  fill?: string,
  title?: string,
  viewBox?: string,
}

const IconTrash = ({ id='ic-trash', className='', stroke='none', fill='currentColor', viewBox='0 0 32 32', title=''}: PropsT) => (
  <Icon customId={id}
    className={classnames('IconTrash', className)}
    stroke={stroke}
    fill={fill}
    title={title}
    viewBox={viewBox}
    path="M8.80955968,8 L11,8 L11,5.99791312 C11,4.89449617 11.8874333,4 12.999615,4 L19.000385,4 C20.1047419,4 21,4.89826062 21,5.99791312 L21,8 L23.1903451,8 L26.9993054,8 C27.5519738,8 28,8.44386482 28,9 C28,9.55228475 27.5525308,10 26.9993054,10 L24.9886849,10 L23.3534297,26.0092049 C23.241123,27.1086907 22.2555354,28 21.1466338,28 L10.853271,28 C9.74679796,28 8.75940775,27.1148189 8.64647516,26.0092049 L7.01121993,10 L5.00069463,10 C4.44802625,10 4,9.55613518 4,9 C4,8.44771525 4.44746922,8 5.00069463,8 L8.80955968,8 Z M13,6 L13,7.99997321 C13,8.00059989 15,8.00060882 19,8 L19,6.00002679 C19,5.99940011 17,5.99939118 13,6 Z M9.0216264,10 L10.6361226,25.805973 C10.6444634,25.8876301 10.7692663,26 10.853271,26 L21.1466338,26 C21.2289389,26 21.3556482,25.885606 21.3637823,25.805973 L22.9782784,10 L9.0216264,10 Z M17.9998003,23 C17.4477731,23 17,22.5866672 17,22.0767302 L17,13.9232698 C17,13.4133328 17.4477731,13 17.9998003,13 C18.5522269,13 19,13.4133328 19,13.9232698 L19,22.0767302 C19,22.5866672 18.5522269,23 17.9998003,23 L17.9998003,23 Z M13.9998003,23 C13.4477731,23 13,22.5866672 13,22.0767302 L13,13.9232698 C13,13.4133328 13.4477731,13 13.9998003,13 C14.5522269,13 15,13.4133328 15,13.9232698 L15,22.0767302 C15,22.5866672 14.5522269,23 13.9998003,23 L13.9998003,23 Z"
  />
)

export default IconTrash
